import { FC } from 'react';
import { Button, Divider, Stack, Typography } from '@mui/material';
import { useGetPreviousActivitiesQuery } from '../../graphql/generated/operations/activity.ts';
import { ReplaceActivity } from '../../components/activity-planning/replace-acitivity.tsx';
import { useLocation, useNavigate } from 'react-router-dom';
import { Paths } from '../../constants/paths.ts';
import { LoadingBackdrop } from '../../components/loading.backdrop.tsx';
import { trackEvent } from '../../utils/analytics.ts';

export const ReplanActivitesPage: FC = () => {
  const { data, loading } = useGetPreviousActivitiesQuery({
    variables: {
      offset: Math.floor(new Date().getTimezoneOffset() / 60) // Timezone offset in hours
    }
  });
  const navigate = useNavigate();
  const location = useLocation();
  const fromWeeklyLog = (location.state as any)?.fromWeeklyLog;

  if (loading) {
    return <LoadingBackdrop />;
  }

  if (!loading && !data?.previousActivities.length) {
    return (
      <Stack spacing={2}>
        <Typography variant="h6"> Plan some new Activities for this week.</Typography>
        <Button
          variant="contained"
          color="primary"
          onClick={() => {
            navigate(Paths.ACTIVITY_PLANNING);
            trackEvent('replan_activity_start');
          }}
        >
          Plan a New Activity
        </Button>
        <Button
          variant="outlined"
          color="primary"
          onClick={() => {
            navigate(Paths.HOME);
            trackEvent('replan_activity_skip');
          }}
        >
          I'll Plan Later
        </Button>
      </Stack>
    );
  }
  return (
    <Stack spacing={2}>
      <Typography variant="h5">Plan Your Activities for Next Week</Typography>
      <Typography variant="body1" color="text.secondary">
        {fromWeeklyLog && 'Great job completing your weekly log! '}Below are your activities from last week. You can repeat any of them, adjust the schedule, or plan something new.
      </Typography>
      <Divider />
      <Typography variant="subtitle1" fontWeight="bold">
        Last Week's Activities
      </Typography>
      {data?.previousActivities.map((activity: any) => {
        const alreadyRepeated = data?.activities?.some((a: any) => a.description === activity.description && a.domainID === activity.domainID && a.type === activity.type);
        return <ReplaceActivity key={activity._id} activity={activity} alreadyRepeated={!!alreadyRepeated} />;
      })}
      <Divider>
        <Typography variant="subtitle1">Or</Typography>
      </Divider>
      <Button
        variant="contained"
        color="primary"
        onClick={() => {
          navigate(Paths.ACTIVITY_PLANNING);
          trackEvent('replan_activity_start');
        }}
      >
        Plan a New Activity
      </Button>
      <Button
        variant="outlined"
        color="primary"
        onClick={() => {
          navigate(Paths.HOME);
          trackEvent('replan_activity_skip');
        }}
      >
        I'll Plan Later
      </Button>
    </Stack>
  );
};
